module.exports = __webpack_public_path__ + "img/utilitaire.981bc75a.png";